import { pxToRem, styled } from '@feast-it/ui/light';

export const Container = styled.div`
  border-bottom: ${pxToRem(1)} solid rgba(18, 18, 18, 0.1);
  padding: ${({ theme }) => theme.spacing[6]} 0;
  z-index: 1;
  position: relative;
`;

interface HeaderProps {
  interactive?: boolean;
}

export const Header = styled.div<HeaderProps>`
  display: flex;
  justify-content: space-between;

  ${({ interactive }) =>
    interactive &&
    `
    :hover {
      cursor: pointer;
    }
  `}
`;

export const Body = styled.div`
  margin-top: ${({ theme }) => theme.spacing[6]};
`;
